module.exports = __webpack_public_path__ + "cr.svg?13c483a397095a9d8703d1eb46328c77";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/cr.svg
// module id = 1309
// module chunks = 0